import { AxiosPromise } from 'axios';

import * as params from '../constants/params';

import { metricsInstance, metricsV2Instance } from './config';
import { res } from './utils';

const getMetricsEndpoints = (): AxiosPromise => metricsV2Instance.get('/endpoints').then(res);

const getMetricsAssets = (): AxiosPromise => metricsInstance.get('/assets').then(res);

type TimestampFormat = 'unix' | 'humanized';

type MetricParams = {
  asset: string;
  currency?: string;
  exchange?: string;
  format?: string;
  miner?: string;
  resolution?: string;
  since?: number;
  timestampFormat?: TimestampFormat;
  until?: number;
};

const getMetric = (
  path = 'unknown',
  { asset, currency, exchange, format, miner, resolution, since, timestampFormat, until }: MetricParams,
): AxiosPromise =>
  metricsInstance
    .get(path, {
      params: {
        [params.ASSET]: asset,
        [params.CURRENCY]: currency,
        [params.EXCHANGE]: exchange,
        [params.FORMAT]: format,
        [params.INTERVAL]: resolution,
        [params.MINER]: miner,
        [params.SINCE]: since,
        [params.TIMESTAMP_FORMAT]: timestampFormat,
        [params.UNTIL]: until,
      },
    })
    .then(res);

const getMetricDependency = (path = 'unknown', subpage = 'unknown'): AxiosPromise =>
  metricsInstance.get(`${path}/${subpage}`).then(res);

const getPrices = ({ asset, since, until, resolution }: MetricParams): AxiosPromise =>
  getMetric('market/price_usd_close', { asset, since, until, resolution });

export default {
  getMetricsAssets,
  getMetricsEndpoints,
  getMetric,
  getMetricDependency,
  getPrices,
};
